module.exports = __webpack_public_path__ + "static/media/140.c295a56a.svg";